import { render, staticRenderFns } from "./AddressesWidget.vue?vue&type=template&id=038ecd56&"
import script from "./AddressesWidget.vue?vue&type=script&lang=js&"
export * from "./AddressesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports